import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import "@/App.css";
import SiteLayout from "@/components/SiteLayout";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Features from "@/pages/Features";
import Contact from "@/pages/Contact";
import Support from "@/pages/Support";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Community from "@/pages/Community";
import DeleteAccount from "@/pages/DeleteAccount";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const el = document.querySelector(hash);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
                return;
            }
        }
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname, hash]);
    return null;
}

function PublicRoutes() {
    return (
        <SiteLayout>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/features" element={<Features />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/support" element={<Support />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/community-guidelines" element={<Community />} />
                <Route path="/delete-account" element={<DeleteAccount />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </SiteLayout>
    );
}

function App() {
    return (
        <div className="App">
            <HelmetProvider>
                <AdminAuthProvider>
                    <BrowserRouter>
                        <ScrollToTop />
                        <Routes>
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route path="/admin" element={<AdminDashboard />} />
                            <Route path="*" element={<PublicRoutes />} />
                        </Routes>
                    </BrowserRouter>
                </AdminAuthProvider>
            </HelmetProvider>
        </div>
    );
}

export default App;
